import { render } from "./InviteSection.vue?vue&type=template&id=24f09e54"
import script from "./InviteSection.vue?vue&type=script&lang=js"
export * from "./InviteSection.vue?vue&type=script&lang=js"
script.render = render

export default script